/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/ginene/"

const GINENE: CommunityData = {
  code: "ginene",
  inviteCode: "ginene",
  name: "GINENE RECORDS",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "EUR",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/gin-030`,
  waitlist: true,
  socials: {},
  styles: {
    global: {
      counterColor: "#03ff00",
      logo: {
        src: `${S3_PREFIX}web-logo.png`,
        styles: "w-[138px] h-[56px] object-contain",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[138px] h-[56px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#000000cc",
      asideBg: "#000000",
      asideStyles: "!gap-0 !py-0 border-r border-[#333333]",
      contentBg: "#000000",
      contentBoxShadow: "",
      bgDesktop: "",
      bgMobile: "",
      mainFont: "font-['HelveticaNeueRegular']",
      primaryButton:
        "bg-[#03ff00] border border-[#03ff00] rounded-[8px] px-[18px] py-[18px] text-[#000000] font-['StarJediRegular'] text-[16px] text-left leading-[100%] !w-fit",
    },
    navigation: {
      iconsColor: "#03ff00",
      sideBarSeparator: "border-r-[1px] border-[#333333]",
      separator: "border-[#333333]",
      item: "font-['HelveticaNeueRegular'] text-[16px] text-[#03ff00] text-left leading-[100%] gap-x-[10px] text-opacity-50 text-center border-b border-[#333333] !pl-0 !py-3",
      itemSelected: "!text-opacity-100",
    },
    communityLanding: {
      container: "",
      titles: "text-[#03ff00] font-['StarJediRegular'] text-[24px] text-left leading-[120%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#ffffff] font-['HelveticaNeueRegular'] text-[14px] text-left leading-[120%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#333333]",
        sectionTitle:
          "text-[#03ff00] font-['StarJediRegular'] text-[24px] text-left leading-[120%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#000000]",
          mediaContainer: "w-[256px] h-[256px] relative overflow-hidden",
          media: "w-[256px] !aspect-square object-cover",
          placeholderMedia: "w-[256px] h-[256px] bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title: "text-[#03ff00] font-['StarJediRegular'] text-[22px] text-left leading-[100%]",
          subtitle:
            "text-[#ffffff] font-['HelveticaNeueRegular'] text-[12px] text-left leading-[120%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#333333]",
        sectionTitle:
          "text-[#03ff00] font-['StarJediRegular'] text-[24px] text-left leading-[120%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#000000]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative overflow-hidden",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full h-full bg-gray-400",
          content: "flex flex-col px-0 sm:px-4 py-4 sm:!py-0 bg-transparent",
          title: "text-[#03ff00] font-['StarJediRegular'] text-[14px] text-left leading-[120%]",
          subtitle:
            "text-[#ffffff] font-['HelveticaNeueRegular'] text-[12px] text-left leading-[120%] mt-2",
          location:
            "text-[#ffffff] font-['HelveticaNeueRegular'] text-[12px] text-left leading-[120%] mt-1",
          date: "text-[#ffffff] font-['HelveticaNeueRegular'] text-[12px] text-left leading-[120%] mt-2",
        },
      },
      shop: {
        title: "text-[#03ff00] font-['StarJediRegular'] text-[22px] text-left leading-[120%]",
        text: "text-[#ffffff] font-['HelveticaNeueRegular'] text-[16px] text-left leading-[120%]",
        customShopImageStyle: "",
      },
    },
    comingSoon: {
      bgColor: "#000000",
      hero: {
        desktop: "",
        mobile: "",
        style: "bg-[#111111]",
      },
      logo: {
        desktop: `${S3_PREFIX}web-logo.png`,
        mobile: `${S3_PREFIX}web-logo.png`,
        style: "w-[92px] h-[37px] sm:w-[138px] sm:h-[56px] object-contain",
      },
      werzLogoColor: "#FFFFFF",
      title: "text-[#03ff00] font-['StarJediRegular'] text-[28px] leading-[120%] text-left",
      text: "text-[#ffffff] font-['HelveticaNeueRegular'] text-[16px] leading-[120%] text-left",
      button:
        "bg-[#03ff00] border border-[#03ff00] rounded-[8px] text-[#000000] font-['StarJediRegular'] text-[16px] text-left p-4 cursor-pointer w-fit",
      footerText:
        "text-[#8D8D8D] font-['HelveticaNeueRegular'] text-[14px] leading-[120%] text-left",
      input: {
        base: "font-['HelveticaNeueRegular'] text-[14px] leading-[120%] w-[256px] px-4 h-[48px] bg-[#111111] text-[#ffffff]",
        border: "#444444",
        borderFocus: "#6d6d6d",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error: "text-[#FF0000] font-['HelveticaNeueRegular'] text-[14px] leading-[120%]",
      skipButton:
        "text-[#8D8D8D] font-['HelveticaNeueRegular'] text-[14px] leading-[120%] cursor-pointer",
      modal: {
        container: "bg-[#111111] px-[40px] py-[48px]",
        title: "text-[#03ff00] font-['StarJediRegular'] text-[24px] leading-[120%] text-center",
        text: "text-[#8D8D8D] font-['HelveticaNeueRegular'] text-[14px] leading-[120%] text-center",
        width: "w-[358px]",
        backdrop: "bg-black/50",
        otpInput:
          "!w-[40px] !h-[50px] rounded-[4px] font-['HelveticaNeueRegular'] text-[16px] leading-[120%] text-center text-[#ffffff] bg-[#111111]",
        otpBorder: "#444444",
        otpBorderFocus: "#6d6d6d",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#000000] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#333333]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4",
        title: "text-[#03ff00] font-['StarJediRegular'] text-[24px] text-left leading-[120%]",
        subtitle:
          "text-[#ffffff] font-['HelveticaNeueRegular'] text-[14px] text-left leading-[120%] mb-4 mt-2",
        button:
          "bg-[#03ff00] border border-[#03ff00] rounded-[8px] px-[18px] py-[18px] gap-y-[6px] !w-fit mb-4 sm:mb-0 text-[#000000] font-['StarJediRegular'] !text-[16px] text-left leading-[100%]",
        questions: "text-[14px] text-left leading-[120%] text-[#ffffff]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#333333]",
        header: "text-[#03ff00] font-['StarJediRegular'] text-[22px] text-left leading-[120%]",
        text: "text-[#ffffff] font-['HelveticaNeueRegular'] text-[14px] text-left leading-[120%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#333333]",
        header: "text-[#03ff00] font-['StarJediRegular'] text-[22px] text-left leading-[120%]",
        text: "text-[#ffffff] font-['HelveticaNeueRegular'] text-[14px] text-left leading-[120%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden gap-y-[10px]",
        mapPinColor: "#03ff00",
        mapStrokeColor: "#00000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#03ff00] font-['StarJediRegular'] text-[22px] text-left leading-[120%]",
        text: "text-[#ffffff] font-['HelveticaNeueRegular'] text-[14px] text-left leading-[120%]",
      },
      tickets: {
        header:
          "text-[#03ff00] font-['StarJediRegular'] text-[22px] text-left leading-[120%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4",
        outerContainer: "flex flex-col !bg-[#000000]",
        innerContainer: "flex flex-col px-4 sm:px-8",
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#000000] border-b border-[#333333] py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#03ff00] font-['StarJediRegular'] text-[14px] text-left leading-[120%] mb-1",
          description:
            "text-[#ffffff] font-['HelveticaNeueRegular'] text-[14px] text-left leading-[120%] mb-1 flex flex-row",
          price: "text-[#ffffff] font-['StarJediRegular'] text-[14px] text-left leading-[100%]",
          quantity: "text-[#03ff00] font-['StarJediRegular'] text-[14px] text-left leading-[100%]",
          status: "text-[#ffffff] font-['StarJediRegular'] text-[14px] text-left leading-[100%]",
          counterContainer:
            "bg-[#000000] border border-[#03ff00] rounded-[8px] px-[12px] py-[12px] gap-x-[16px] !w-fit",
          button:
            "bg-[#000000] border border-[#03ff00] rounded-[8px] px-[12px] py-[12px] text-[#03ff00] font-['StarJediRegular'] text-[14px] text-left leading-[100%] !w-fit",
          plusMinusColor: "#03ff00",
        },
      },
    },
    linktree: {
      bgDesktop: "",
      bgMobile: "",
      bgColor: "#000000cc",
      bgMedia: "",
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative bg-[#000000cc] px-4 py-12 sm:p-[64px]",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[2.5px] border-[#03ff00] object-cover",
        name: "text-[#03ff00] font-['StarJediRegular'] text-[24px] text-center mt-4 mb-1",
        location: "text-[#03ff00] font-['StarJediRegular'] text-[18px] text-center mb-2",
        description:
          "text-[#ffffff] font-['HelveticaNeueRegular'] text-[16px] text-center leading-[120%] mb-4 max-w-[500px]",
        socialMediaIconColor: "#03ff00",
        button:
          "bg-[#000000] border border-[#03ff00] rounded-[8px] px-[12px] py-[12px] text-[#03ff00] font-['StarJediRegular'] text-[14px] text-left leading-[100%] !w-fit cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#000000] border border-[#03ff00] rounded-[8px] text-[#ffffff] font-['HelveticaNeueRegular'] text-[16px] leading-[120%]",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] flex flex-col justify-center items-center p-[34px] mb-[32px] bg-[#000000] border border-[#03ff00] rounded-[8px]",
          title: "font-['StarJediRegular'] text-[18px] text-[#03ff00] text-center mb-1",
          text: "text-[#ffffff] font-['HelveticaNeueRegular'] text-[16px] leading-[120%] text-center",
          button:
            "bg-[#000000] border border-[#03ff00] rounded-[8px] px-[12px] py-[12px] text-[#03ff00] font-['StarJediRegular'] text-[14px] text-left leading-[100%] !w-fit cursor-pointer mt-4",
        },
        header: "font-['StarJediRegular'] text-[16px] text-[#03ff00] text-center mb-[10px]",
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#000000] border border-[#03ff00] rounded-[8px]",
          duration: "text-[12px] text-[#ffffff] font-['HelveticaNeueRegular']",
          name: "text-[16px] leading-[16px] text-[#03ff00] font-['StarJediRegular'] one-line-truncate sm:w-[390px] w-[65vw]",
          plusIconColor: "#03ff00",
          media: "border border-[#03ff00] overflow-hidden rounded-[16px] m-2",
        },
        event: {
          container:
            "overflow-hidden sm:w-[500px] w-[95vw] bg-[#000000] border border-[#03ff00] rounded-[8px]",
          name: "text-[16px] mb-1 text-[#03ff00] font-['StarJediRegular'] one-line-truncate sm:w-[370px] w-[60vw]",
          startDate:
            "w-[64px] h-[64px] rounded-[6px] flex flex-col justify-center items-center gap-1 bg-[#03ff00] text-[#000000] font-['StarJediRegular'] text-[14px] text-center",
          duration: "text-[12px] text-[#ffffff] font-['HelveticaNeueRegular']",
          location: "text-[12px] text-[#ffffff] font-['HelveticaNeueRegular']",
          button:
            "bg-[#000000] border border-[#03ff00] rounded-[8px] px-[12px] py-[12px] text-[#03ff00] font-['StarJediRegular'] text-[14px] text-left leading-[100%] !w-fit cursor-pointer mt-3",
          product: {
            container:
              "min-h-[68px] px-4 py-3 flex justify-between gap-4 border-t border-[#03ff00]",
            name: "text-[#03ff00] font-['StarJediRegular'] text-[16px] one-line-truncate sm:w-[390px] w-[65vw]",
            price: "text-[#ffffff] font-['StarJediRegular'] text-[14px]",
            status: "text-[#ffffff] font-['StarJediRegular'] text-[14px] text-left leading-[100%]",
            link: "text-[#ffffff] font-['HelveticaNeueRegular'] text-[12px] leading-[120%]",
            button:
              "bg-[#000000] border border-[#03ff00] rounded-[8px] px-[12px] py-[12px] text-[#03ff00] font-['StarJediRegular'] text-[14px] text-left leading-[100%] !w-fit cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[#ffffff] font-['HelveticaNeueRegular'] text-[16px] leading-[120%] text-center mt-4 cursor-pointer mb-[32px]",
      },
      news: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#000000] border border-[#03ff00] rounded-[8px] text-[#ffffff] font-['HelveticaNeueRegular'] text-[16px] leading-[120%]",
        header: "font-['StarJediRegular'] text-[16px] text-[#03ff00] text-center mb-[10px]",
        container: "flex flex-col gap-4",
        oneNews: {
          container:
            "h-[64px] cursor-pointer bg-[#000000] sm:w-[500px] w-[95vw] rounded-[8px] flex justify-between border border-[#03ff00]",
          name: "text-[16px] leading-[16px] text-[#03ff00] font-['StarJediRegular'] one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#03ff00",
          created: "text-[#ffffff] font-['HelveticaNeueRegular'] text-[12px]",
          media: "border border-[#03ff00] overflow-hidden rounded-[16px] m-2",
        },
        seeAllNews:
          "text-[#ffffff] font-['HelveticaNeueRegular'] text-[16px] leading-[120%] text-center mt-4 cursor-pointer mb-[32px]",
      },
      otherLinks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center bg-[#000000] border border-[#03ff00] rounded-[8px] text-[#ffffff] font-['HelveticaNeueRegular'] text-[16px] leading-[120%]",
        header: "font-['StarJediRegular'] text-[16px] text-[#03ff00] text-center mb-[10px]",
        container: "flex flex-col gap-[10px] mb-[40px]",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] bg-[#000000] w-[95vw] rounded-[8px] flex justify-between border border-[#03ff00]",
          name: "text-[16px] text-[#03ff00] font-['StarJediRegular']",
          triangleIconColor: "#03ff00",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full object-cover border border-[#03ff00]",
        },
      },
      footer: {
        WERZlogoColor: "#FFFFFF",
        text: "text-[#ffffff] font-['HelveticaNeueRegular'] text-[12px] text-left",
      },
    },
  },
}

export default GINENE
